/** Bucățile de adresă ale paginilor de serviciu, într-un singur loc.
 *
 *  Aceeași poveste ca la caseSlugs: App.tsx montează BrowserRouter, care are
 *  nevoie de `window`, deci prerandarea are propriul arbore de rute. Două liste
 *  ar devia, iar o rută adăugată doar în App ar merge la navigare și ar ajunge
 *  goală la crawler. */
export const SERVICE_SLUGS = [
  "web",
  "mobile",
  "desktop",
  "automation",
  "ai",
  "data",
  "audit",
] as const;
